import React, { useState } from "react";
import { motion } from "framer-motion";
import { filterRecommendationStatic, filterImoji } from "../../static-data";
import { FILTER_NAMES } from "../../../shared/enums";
import loadable from "@loadable/component";

const LazyImg = loadable(() => import("../common/LazyImg"));
const FadeIn = loadable(() => import("../common/FadeIn"));
const ImageLoader = loadable(() => import("../common/ImageLoader"));

const FILTER_NAMES_UPDATED = {
  ...FILTER_NAMES,
  BB_2: "Basic Breather",
};

const filterImojiUpdated = {
  ...filterImoji,
  BB_2: filterImoji.BB,
};

const FilterRecommendation = () => {
  const [activeFilter, setActiveFilter] = useState(
    Object.keys(filterRecommendationStatic)[0]
  );

  return (
    <div className="p-filter-recommendation">
      <div className="container">
        <FilterRecommendationTab
          recommendation={filterRecommendationStatic}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
        />
        <FilterRecommendationTabBody
          recommendation={filterRecommendationStatic}
          activeFilter={activeFilter}
        />
      </div>
    </div>
  );
};

function FilterRecommendationTab({
  recommendation,
  activeFilter,
  setActiveFilter,
}) {
  return (
    <div className="p-filter-recommendation__header">
      <h2 className="p-filter-recommendation__title">
        Not sure which filter is for you?
      </h2>
      <ul className="p-filter-recommendation__tab-list">
        {Object.keys(recommendation).map((key) => (
          <li
            key={key}
            style={{ "--backgroundColor": recommendation[key].color }}
          >
            <button
              type="button"
              className={`p-filter-recommendation__tab-button ${
                activeFilter === key ? "active" : ""
              }`}
              onClick={() => setActiveFilter(key)}
            >
              {recommendation[key].label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

function FilterRecommendationTabBody({ recommendation, activeFilter }) {
  const { description, cleanAir, hepa, link, carbon } =
    recommendation[activeFilter];

  return (
    <motion.div
      className={`p-filter-recommendation__body ${activeFilter}`}
      key={activeFilter}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.4,
        ease: "easeOut",
      }}
      style={{ "--backgroundColor": recommendation[activeFilter].color }}
    >
      <div className="p-filter-recommendation__grid">
        <div className="p-filter-recommendation__content">
          <h3 className="p-filter-recommendation__content-title">
            The{" "}
            <FadeIn>
              <LazyImg
                src={filterImojiUpdated[activeFilter]}
                alt={FILTER_NAMES_UPDATED[activeFilter]}
              />
            </FadeIn>{" "}
            {FILTER_NAMES_UPDATED[activeFilter]}
          </h3>
          {description && (
            <div className="p-filter-recommendation__content-description">
              {description}
            </div>
          )}
          {(cleanAir || hepa) && (
            <ul className="p-filter-recommendation__content-list">
              {cleanAir && (
                <li>
                  <FadeIn>
                    <svg className="icon icon-cube">
                      <use xlinkHref="#icon-cube"></use>
                    </svg>
                  </FadeIn>
                  <span>{cleanAir}</span>
                </li>
              )}
              {hepa && (
                <li>
                  <FadeIn>
                    <svg className="icon icon-filter-box">
                      <use xlinkHref="#icon-filter-box"></use>
                    </svg>
                  </FadeIn>
                  <span>{hepa}</span>
                </li>
              )}

              {carbon && (
                <li>
                  <FadeIn>
                    <svg className="icon icon-carbon">
                      <use xlinkHref="#icon-carbon"></use>
                    </svg>
                  </FadeIn>
                  <span>{carbon}</span>
                </li>
              )}
            </ul>
          )}
          {link && (
            <a href={link} className="button button--primary">
              Add to Cart
            </a>
          )}
        </div>
        <div className="p-filter-recommendation__image-stack">
          {Object.keys(recommendation).map((key) => {
            const img = recommendation[key].image;
            return (
              <ImageLoader
                key={key}
                className={`p-filter-recommendation__image ${
                  activeFilter === key
                    ? "p-filter-recommendation__image--active"
                    : "p-filter-recommendation__image--hidden"
                }`}
                image={img.src}
                webp={img.srcWebp}
                alt={recommendation[key].label}
                type="image/jpeg"
                placeholderAspectRatio={350 / 380}
                noLazyLoad
              />
            );
          })}
        </div>
      </div>
    </motion.div>
  );
}

export default FilterRecommendation;
